namespace RioERP.Reports {
    export interface GstReportSummaryWithGstinRow {
        Id?: number;
        ESourceType?: Web.Enums.SourceType;
        FranchiseeId?: number;
        Name?: string;
        OrderMonth?: Web.Enums.EMonths;
        OrderYear?: Web.Enums.EYears;
        TotalTaxableAmount?: number;
        TotalTaxAmount?: number;
        CgstAmount?: number;
        SgstAmount?: number;
        IgstAmount?: number;
        TotalTax?: number;
        Gstin?: string;
    }

    export namespace GstReportSummaryWithGstinRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Reports.GstReportSummaryWithGstin';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ESourceType = "ESourceType",
            FranchiseeId = "FranchiseeId",
            Name = "Name",
            OrderMonth = "OrderMonth",
            OrderYear = "OrderYear",
            TotalTaxableAmount = "TotalTaxableAmount",
            TotalTaxAmount = "TotalTaxAmount",
            CgstAmount = "CgstAmount",
            SgstAmount = "SgstAmount",
            IgstAmount = "IgstAmount",
            TotalTax = "TotalTax",
            Gstin = "Gstin"
        }
    }
}
